import { IPayment } from '@data/interfaces/visits/payment.interface';

export class Payment {
  isPaid: boolean;
  constructor(data: IPayment) {
    Object.assign(this, data);
  }
}
